var map = {
	"./music-instructions.json": 4676,
	"./music-library-intro2024.json": 4677,
	"./music-library-launch2024.json": 4678,
	"./music-progression.json": 4679,
	"./startSourcesAdvanced.json": 4680,
	"./startSourcesSimple.json": 4681,
	"./startSourcesSimple2.json": 4682,
	"./startSourcesTracks.json": 4683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4454;